import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconMenu from 'components/IconMenu';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MenuItem from '@mui/material/MenuItem';
import { ScheduledDashboardEmailConfig } from 'components/DashboardSendModal/ScheduledDashboardEmailConfigForm/types';
import Typography from '@mui/material/Typography';
import { formatDate } from 'helpers/dateHelper';
import { useSelector } from 'store/hooks';
import SubmitModal from 'components/Submits/SubmitModal';
import { styled } from '@mui/material';
import { useForceSendDashboardMutation } from '../hooks/scheduleDashboards';

type Props = {
    sdeId: number;
    config: ScheduledDashboardEmailConfig;
    sender: string | undefined;
    onDeleteScheduleConfig: (arg1: number) => void;
    onEditScheduleConfig?: (arg1: number) => void;
};

const StySingleSide = styled('div', {
    name: 'StySingleSide',
})(({ theme }) => ({
    display: 'flex',
    background: theme.palette.lightGrey,
    marginBottom: '5px',
    justifyContent: 'space-between',
}));

const ScheduledDashboardEmailItem = ({
    sdeId,
    config,
    sender,
    onDeleteScheduleConfig,
    onEditScheduleConfig = undefined,
}: Props): React.ReactElement => {
    const { t } = useTranslation();
    const [forceSendDashboardModal, setForceSendDashboardModal] =
        useState(false);
    const isSupportUser = useSelector((state) => state.vision.isSupportUser);
    const forceSendDashboardMutation = useForceSendDashboardMutation();

    return (
        <>
            <StySingleSide key={sdeId}>
                <Typography sx={{ p: '10px', wordBreak: 'break-word' }}>
                    {t('sendDashboard.scheduledEmailItem', {
                        recipient: config.recipients,
                        recurrence: t(`sendDashboard.${config.recurrence}`),
                        firstSentDate: formatDate(
                            new Date(config.firstSentDate),
                        ),
                    })}
                    {sender && ` ${t('common.per')} ${sender}`}
                </Typography>
                <IconMenu iconElement={<MoreVertIcon fontSize="small" />}>
                    {onEditScheduleConfig && (
                        <MenuItem onClick={() => onEditScheduleConfig(sdeId)}>
                            {t('common.edit')}
                        </MenuItem>
                    )}
                    {isSupportUser && (
                        <MenuItem
                            onClick={() => setForceSendDashboardModal(true)}
                        >
                            {t('sendDashboard.sendAgain')}
                        </MenuItem>
                    )}
                    <MenuItem onClick={() => onDeleteScheduleConfig(sdeId)}>
                        {t('common.delete')}
                    </MenuItem>
                </IconMenu>
            </StySingleSide>
            <SubmitModal
                submit={() => forceSendDashboardMutation.mutate({ id: sdeId })}
                dialogText={t('sendDashboard.validationForceSendingText')}
                dialogTitle={t('sendDashboard.sendAgain')}
                open={forceSendDashboardModal && isSupportUser}
                setOpen={setForceSendDashboardModal}
            />
        </>
    );
};

export default ScheduledDashboardEmailItem;
